// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tagInput_wrapper_3toqPDM","inputWrapper":"tagInput_inputWrapper_240CCPo"};